
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import MortgageActivitiesTimelineItem from "./MortgageActivitiesTimelineItem.vue";

interface MortgageActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "MortgageActivitiesView",
  components: { MortgageActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): MortgageActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_MORTGAGE_FAILURE,
          ADD_MORTGAGE_SUCCESS,
          UPDATE_MORTGAGE_FAILURE,
          UPDATE_MORTGAGE_SUCCESS,
          DELETE_MORTGAGE_SUCCESS,
          DELETE_MORTGAGE_FAILURE
          `.replace(/\s/g, ""),
        activityType: "MortgageActivity",
        "data.screenName__in": `/mortgages,/Mortgages`
      };
    }
  }
});
